<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App',
  mounted: function()
  {
    function isMobile(){
      var UserAgent = navigator.userAgent;
      if (UserAgent.match(/iPhone|iPod|iPad|Android|Windows CE|BlackBerry|Symbian|Windows Phone|webOS|Opera Mini|Opera Mobi|POLARIS|IEMobile|lgtelecom|nokia|SonyEricsson/i) != null || UserAgent.match(/LG|SAMSUNG|Samsung/) != null)
      {
          return true;
      }else{
          return false;
      }
    }
    if(isMobile())
    {
      // location.href = "https://m.dr.soldoc.co.kr"
    }
    // console.log("scale" + window.devicePixelRatio);

    // dr.soldoc.co.kr 검색 로봇 접근 차단
    if (window.location.hostname === 'dr.soldoc.co.kr' || window.location.hostname === 'm.dr.soldoc.co.kr') {
      const meta = document.createElement('meta');
      meta.name = "robots";
      meta.content = "noindex";
      document.head.appendChild(meta);
    }
  }
}
</script>

<style>
@import url('https://fonts.googleapis.com/css2?family=Noto+Sans+KR:wght@100;300;400;500;700;900&display=swap');
#app {
  /* font-family: 'Avenir', Helvetica, Arial, sans-serif; */
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  font-family: 'Pretendard';
  
  /* text-align: center;
  color: #2c3e50;
  margin-top: 60px; */
  overflow-x: hidden;
  margin: 0;
  padding: 0;
  
}
.btn{
  text-decoration: none;
}
.btn:hover,
.btn:focus,
.btn:visited {
  color: inherit;
  text-decoration: none;
}

.v-application {
  font-family: 'Pretendard', sans-serif !important;
}

@font-face {
  font-family:'Pretendard';
  src: url('assets/fonts/Pretendard-Thin.ttf') format('truetype');
  font-weight: 100;
}
@font-face {
  font-family:'Pretendard';
  src: url('assets/fonts/Pretendard-ExtraLight.ttf') format('truetype');
  font-weight: 200;
}
@font-face {
  font-family:'Pretendard';
  src: url('assets/fonts/Pretendard-Light.ttf') format('truetype');
  font-weight: 300;
}
@font-face {
  font-family:'Pretendard';
  src: url('assets/fonts/Pretendard-Regular.ttf') format('truetype');
  font-weight: 400;
}
@font-face {
  font-family:'Pretendard';
  src: url('assets/fonts/Pretendard-Medium.ttf') format('truetype');
  font-weight: 500;
}
@font-face {
  font-family:'Pretendard';
  src: url('assets/fonts/Pretendard-SemiBold.ttf') format('truetype');
  font-weight: 600;
}
@font-face {
  font-family:'Pretendard';
  src: url('assets/fonts/Pretendard-Bold.ttf') format('truetype');
  font-weight: 700;
}
@font-face {
  font-family:'Pretendard';
  src: url('assets/fonts/Pretendard-ExtraBold.ttf') format('truetype');
  font-weight: 800;
}
@font-face {
  font-family:'Pretendard';
  src: url('assets/fonts/Pretendard-Black.ttf') format('truetype');
  font-weight: 900;
}

</style>



// WEBPACK FOOTER //
// src/App.vue